var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Past Links")]),
      _vm._v(" "),
      _vm._l(_vm.pastLinks, function(pastLink) {
        return _c("div", { key: pastLink.signup_token, staticClass: "well" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(0, true),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-10" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v("Signup Token")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("a", { staticClass: "form-control overflow-wrap" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(pastLink.signup_token) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default token-copy",
                        attrs: {
                          "data-clipboard-text": pastLink.signup_token,
                          type: "button"
                        }
                      },
                      [_vm._v("Copy Token")]
                    )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v("\n            Link Activation Date *\n          ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        new Date(pastLink.activation_date).toLocaleString()
                      ) +
                      " " +
                      _vm._s(_vm.timezoneAbbrev) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v("\n            Link Expiration Date *\n          ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        new Date(pastLink.expiration_date).toLocaleString()
                      ) +
                      " " +
                      _vm._s(_vm.timezoneAbbrev) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v(" License End Date")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(pastLink.license_end_date) +
                      "\n          "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v("\n            Link Total Capacity\n          ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(pastLink.total_capacity) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v("Link Used Capacity")
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(pastLink.used_capacity))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v("Link Remaining Capacity")
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(pastLink.remaining_capacity))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v("Link Notes")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("pre", { staticClass: "notes" }, [
                    _vm._v(_vm._s(pastLink.notes || "(none)"))
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _c("i", [
              _vm._v("\n        " + _vm._s(_vm.timezoneMessage) + "\n      ")
            ])
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-2" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("p", { staticClass: "control-label" }, [_vm._v("Link Status")]),
        _vm._v(" "),
        _c("p", [_vm._v("Expired")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }